import AnimationClip from '../AnimationClip';
import { Tween } from '@tweenjs/tween.js';
import GameObject from '../../../GameObject/GameObject';
import ColorFilter from '../../../Component/ColorFilter';
import TransformComponent from '../../../Component/Transform';

export class NodeRelease extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta?: any
    ): IterableIterator<number> {
        const transform: TransformComponent = gameObject.getComponent(
            TransformComponent
        );
        const colorFilter: ColorFilter = gameObject.getComponent(ColorFilter);

        if (colorFilter) {
            const colorTween: Tween = this.getTween(colorFilter);
            colorTween.to({ brightness: 1 }, 100).start(this.elapsedTime);
        }

        const scaleTween: Tween = this.getTween(transform.scale);
        scaleTween.to({ x: 1, y: 1 }, 100);

        yield* this.startTween(scaleTween);
    }
}
